import * as React from 'react';

import { cn } from '@/components/atoms/primitives/utils';

/**
 * WEB-1001 — the design-system filter chip (DS 1.9.0 `.m-chip`):
 * 32 visual on every pointer, pill, 13/500, with the 44 coarse-pointer hit
 * floor. Selection is `aria-pressed` (a toggle), filled with the accent — or
 * with the category hue when `category` is set, whose dot marks identity at
 * rest.
 */
export const CHIP_CATEGORIES = [
  'music',
  'sports',
  'food',
  'science-tech',
  'art',
  'drinks',
  'business-networking',
  'community-culture',
  'wellness',
  'hobbies-interests',
] as const;

export type ChipCategory = (typeof CHIP_CATEGORIES)[number];

interface ChipOwnProps {
  selected?: boolean;
  category?: ChipCategory;
}

export interface ChipProps
  extends ChipOwnProps, Omit<React.ComponentPropsWithoutRef<'button'>, 'type'> {
  type?: 'button' | 'submit';
}

function chipClassName(category: ChipCategory | undefined, className?: string): string {
  return cn('m-chip', category && ['m-chip--cat', `m-chip--${category}`], className);
}

export const Chip = React.forwardRef<HTMLButtonElement, ChipProps>(function Chip(
  { selected, category, className, children, type = 'button', ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      aria-pressed={selected === undefined ? undefined : selected}
      className={chipClassName(category, className)}
      {...props}
    >
      {category ? <span aria-hidden="true" className="m-chip__dot" /> : null}
      {children}
    </button>
  );
});
